// extracted by mini-css-extract-plugin
export var scrollButton = "styles-module--scrollButton--2oxoI";
export var left = "styles-module--left--zuUF0";
export var right = "styles-module--right--3cnK2";
export var buttonIcon = "styles-module--buttonIcon--njTmI";